import { useState } from 'react';
import { Box, Loader2 } from 'lucide-react';
import { Dialog, DialogContent, DialogDescription, DialogTitle, DialogTrigger } from '@/components/ui/dialog';

export const isProductModelPath = (value: string | null | undefined): value is string =>
  typeof value === 'string' && /^\/models\/[a-zA-Z0-9_-]+(?:\/[a-zA-Z0-9_-]+)*\/index\.html$/.test(value);

export default function Product3DViewer({ title, url }: { title: string; url: string }) {
  const [open, setOpen] = useState(false);
  const [loaded, setLoaded] = useState(false);
  if (!isProductModelPath(url)) return null;
  return (
    <Dialog open={open} onOpenChange={(next) => { setOpen(next); if (!next) setLoaded(false); }}>
      <DialogTrigger asChild>
        <button type="button" className="mt-3 flex w-full items-center gap-3 rounded-2xl border border-copper/40 bg-copper/10 p-4 text-right text-foreground transition hover:bg-copper/20" data-testid="product-3d-trigger">
          <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-copper text-white"><Box className="h-6 w-6" /></span>
          <span><strong className="block text-sm">نمایش سه‌بعدی محصول</strong><span className="mt-1 block text-[11px] text-muted-foreground">چرخش ۳۶۰ درجه، نمای داخل و انفجاری</span></span>
        </button>
      </DialogTrigger>
      <DialogContent className="z-[60] flex h-[calc(100dvh-1rem)] max-h-[calc(100dvh-1rem)] w-[calc(100vw-1rem)] max-w-[1400px] flex-col gap-0 overflow-hidden rounded-2xl border-0 bg-background p-0" dir="rtl">
        <div className="shrink-0 border-b border-border bg-background px-5 py-4 pr-16">
          <DialogTitle className="text-right text-sm leading-6 md:text-base">نمای سه‌بعدی {title}</DialogTitle>
          <DialogDescription className="mt-1 text-right text-[11px]">با موس بچرخانید و زوم کنید؛ برای دیدن قطعات، «نمای داخل» یا «انفجاری» را بزنید. هندسه بدون اندازه‌گذاری، تقریبی است.</DialogDescription>
        </div>
        <div className="relative min-h-0 min-w-0 flex-1 bg-[#f3f5ed]">
          {!loaded && <div className="pointer-events-none absolute inset-0 z-10 flex items-center justify-center gap-3 bg-[#f3f5ed] text-sm text-muted-foreground" role="status"><Loader2 className="h-5 w-5 animate-spin" />در حال آماده‌سازی نمایشگر…</div>}
          {open && <iframe src={url} title={`مدل سه‌بعدی ${title}`} loading="eager" className="relative z-0 block h-full min-h-0 w-full border-0" allow="fullscreen; autoplay" onLoad={() => setLoaded(true)} />}
        </div>
      </DialogContent>
    </Dialog>
  );
}
